"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = _interopRequireDefault(require("../styles"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _tokens = require("../styles/tokens");

var _excluded = ["classes", "children", "disabled"];

var styles = function styles(theme) {
  return {
    menuRoot: {
      border: _tokens.borderWidthThin + " solid " + theme.palette.grey[300]
    },
    menuItemRoot: {
      fontSize: _tokens.fontSizeDefault,
      borderBottom: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
      paddingTop: '.75rem',
      paddingBottom: '.75rem',
      '&:focus, &:hover': {
        backgroundColor: theme.palette.grey[250],
        color: theme.palette.grey[600]
      },
      '&:last-child': {
        borderBottom: 'none'
      },
      '&$menuItemSelected': {
        backgroundColor: theme.palette.ctaColor.base,
        color: theme.palette.grey[100],
        '&:focus': {
          backgroundColor: theme.palette.ctaColor.hover,
          color: theme.palette.grey[100]
        },
        '&:hover': {
          backgroundColor: theme.palette.ctaColor.hover,
          color: theme.palette.grey[100]
        }
      },
      '&:active, &:hover&:active': {
        backgroundColor: theme.palette.ctaColor.active,
        color: theme.palette.grey['100']
      },
      minHeight: _tokens.sizingXxLarge,
      lineHeight: _tokens.lineHeightHeader3
    },
    menuItemSelected: {
      backgroundColor: theme.palette.ctaColor.base,
      color: theme.palette.grey[100],
      '&:focus:hover': {
        backgroundColor: theme.palette.ctaColor.hover,
        color: theme.palette.grey[100]
      },
      '&:focus': {
        backgroundColor: theme.palette.ctaColor.hover,
        color: theme.palette.grey[100]
      },
      '&:hover': {
        backgroundColor: theme.palette.ctaColor.hover,
        color: theme.palette.grey[100]
      }
    }
  };
};

var SelectionMenuItem = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
      children = props.children,
      disabled = props.disabled,
      rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_MenuItem.default, (0, _extends2.default)({
    classes: {
      root: classes.menuItemRoot,
      selected: classes.menuItemSelected
    },
    disabled: disabled,
    "aria-disabled": disabled ? true : false,
    ref: ref
  }, rest), children);
}); // necessary to add an explicit display name, since docgen can't seem to
// extract one from a forwardRef'd component


SelectionMenuItem.displayName = 'SelectionMenuItem';
SelectionMenuItem.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,

  /**
   * The text of the item.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * If `true`, the item will be disabled.
   */
  disabled: _propTypes.default.bool
};

var _default = (0, _styles.default)(styles, {
  name: 'SelectionMenuItem'
})(SelectionMenuItem);

exports.default = _default;